import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight, Calendar } from 'lucide-react';
export function Summit() {
  return <section id="summit" className="py-24 lg:py-40 bg-deep-azure text-white relative overflow-hidden" data-id="element-263">
      {/* Amalfi-inspired ocean imagery */}
      <div className="absolute inset-0" data-id="element-264">
        <img src="https://images.unsplash.com/photo-1533105079780-92b9be482077?auto=format&fit=crop&q=80&w=1920" alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" data-id="element-265" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-deep-azure via-deep-azure/90 to-deep-azure/70" data-id="element-266"></div>
      <div className="absolute inset-0 ocean-pattern opacity-30" data-id="element-267"></div>
      <div className="absolute bottom-0 right-0 w-[50%] h-[60%] bg-golden-yellow/10 blur-[140px] rounded-full" data-id="element-268"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-269">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center" data-id="element-270">
          <div className="lg:col-span-7" data-id="element-271">
            <FadeIn data-id="element-272">
              <p className="text-[11px] font-semibold tracking-[0.4em] uppercase text-golden-yellow mb-8" data-id="element-273">
                Events · Convenings
              </p>
              <h2 className="text-4xl md:text-5xl lg:text-7xl font-display font-medium leading-[1.05] mb-3 tracking-tight" data-id="element-274">
                The LeadHERship
              </h2>
              <h2 className="text-4xl md:text-5xl lg:text-7xl font-display italic font-light leading-[1.05] mb-12 text-golden-yellow tracking-tight" data-id="element-275">
                Equity Summit.
              </h2>

              <div className="editorial-rule w-32 mb-12" data-id="element-276"></div>

              <div className="space-y-6 text-lg text-white/75 leading-relaxed mb-10 max-w-2xl font-light" data-id="element-277">
                <p data-id="element-278">
                  A modern ecosystem gathering focused on measurable
                  advancement, economic participation, leadership conversations,
                  and strategic opportunities for women founders and leaders.
                </p>
                <p className="font-display italic text-xl text-golden-yellow/90" data-id="element-279">
                  Where ecosystem intelligence meets elevated convening.
                </p>
              </div>

              <div className="flex items-center gap-3 mb-10 text-sm text-white/60 font-light" data-id="element-280">
                <Calendar className="w-4 h-4 text-golden-yellow" data-id="element-281" />
                <span className="tracking-wide" data-id="element-282">
                  Aligned with Small Business Week initiatives & global
                  ecosystem partnerships
                </span>
              </div>

              <a href="#cta" className="inline-flex items-center gap-2 border border-golden-yellow hover:bg-golden-yellow text-golden-yellow hover:text-deep-azure font-medium text-sm tracking-[0.05em] uppercase py-4 px-8 rounded-sm transition-all duration-300 group" data-id="element-283">
                Request Summit Details
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-284" />
              </a>
            </FadeIn>
          </div>

          <FadeIn delay={0.3} direction="left" className="lg:col-span-5" data-id="element-285">
            <div className="relative" data-id="element-286">
              <div className="aspect-[3/4] overflow-hidden rounded-sm" data-id="element-287">
                <img src="https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&q=80&w=900" alt="Modern leadership summit" className="w-full h-full object-cover" data-id="element-288" />
                <div className="absolute inset-0 bg-gradient-to-t from-deep-azure/40 via-transparent to-transparent" data-id="element-289"></div>
              </div>
              {/* Floating editorial card */}
              <div className="absolute -bottom-6 -left-6 glass-card p-6 max-w-xs" data-id="element-290">
                <p className="text-[10px] font-semibold tracking-[0.25em] uppercase text-golden-yellow mb-2" data-id="element-291">
                  Inaugural Convening
                </p>
                <p className="text-base font-display italic text-white leading-snug" data-id="element-292">
                  An international summit for the future of women's economic
                  advancement.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}